<div class="igx-input-group igx-input-group--cosy igx-input-group--box igx-input-group--placeholder igx-input-group--focused" style="padding:0 8px;">
    <div class="igx-input-group__wrapper">
        <div class="igx-input-group__bundle">
            <igx-icon igxprefix class="material-icons igx-icon" aria-hidden="true" style="color: var(--forge-theme-text-high);">search</igx-icon>
            <div class="igx-input-group__bundle-main">
                <input igxinput id="customFilter" #filterInput
                        (keydown)="onInputKeyDown($event)" [(ngModel)]="columnFilterText"
                        [type]="filterColumnType" placeholder="Search"
                        class="igx-input-group__input ng-dirty ng-touched"
                        style="color: var(--forge-theme-text-high);">
            </div>
        </div>
    </div>
</div>
<footer class="igx-excel-filter__menu-footer custom-filter-footer">
    <div fxFlex="auto" fxLayout="row" fxLayoutAlign="start center">
        <forge-button telemetry="Filter-Cancel" (click)="closeFilter()" full-width>
            Cancel
        </forge-button>
        <forge-button class="tt-margin--left" variant="raised" telemetry="Filter-Apply" (click)="applyFilter()" full-width>
            Apply
        </forge-button>
    </div>
</footer>
